import React from 'react';
import './ErrorModal.css';
import { FaTimes, FaExclamationTriangle, FaCheckCircle, FaInfoCircle } from 'react-icons/fa';

const ErrorModal = ({ 
  isOpen, 
  onClose, 
  title, 
  message, 
  type = 'error', // 'error', 'success', 'info', 'warning'
  buttonText = 'Close'
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'success':
        return <FaCheckCircle className="modal-icon success" />;
      case 'info':
        return <FaInfoCircle className="modal-icon info" />;
      case 'warning':
        return <FaExclamationTriangle className="modal-icon warning" />;
      default:
        return <FaExclamationTriangle className="modal-icon error" />;
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="error-modal-overlay" onClick={handleOverlayClick}>
      <div className="error-modal-container">
        <div className="error-modal-header">
          <button className="error-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        <div className="error-modal-content">
          <div className="error-modal-icon-container">
            {getIcon()}
          </div>
          
          <h2 className="error-modal-title">{title}</h2>
          <p className="error-modal-message">{message}</p>
          
          <button 
            className={`error-modal-button ${type}`}
            onClick={onClose}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;
